module.exports = __webpack_public_path__ + "img/summer.6d9e5ea9.webp";